import React from 'react';
import { iconPerson, iconHelp, iconGlobe, iconSignOut } from '@tesla/design-system-icons';
import { NavItemGroup, NavItem, Icon, List, ListItem, Text } from '@tesla/design-system-react';
import { shape, string, func, bool } from 'prop-types';
import { parseJwt } from '../../SearchBar/Helpers/Utilities.js';
import styles from '../styles.module.css.js';
import { DEFAULT_COUNTRIES_SHORT_PER_REGION } from '../RegionSelector/constants.js';

var UserProfile = function UserProfile(_ref) {
  var _userInfo$title, _userInfo$email;
  var logout = _ref.logout,
    _ref$supportLink = _ref.supportLink,
    supportLink = _ref$supportLink === void 0 ? {} : _ref$supportLink,
    osAccessToken = _ref.osAccessToken,
    _ref$regionSelector = _ref.regionSelector,
    regionSelector = _ref$regionSelector === void 0 ? {} : _ref$regionSelector;
  var userInfo = parseJwt(osAccessToken);
  var userName = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || "".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.given_name) || '', " ").concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.family_name) || '');
  return /*#__PURE__*/React.createElement(NavItemGroup, {
    layout: "vertical"
  }, /*#__PURE__*/React.createElement(NavItem, {
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      data: iconPerson,
      size: "xl"
    }),
    className: styles['tw-react--site-header--user-profile--list-container']
  }, /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(ListItem, {
    className: styles['tw-react--site-header--user-profile--list-item']
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "500",
    is: "p",
    className: "--tds-theme-foreground",
    contrast: "high",
    id: "tw-react--site-header--user-profile--user-name"
  }, userName)), /*#__PURE__*/React.createElement(ListItem, {
    className: styles['tw-react--site-header--user-profile--list-item']
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "400",
    is: "p",
    className: "--tds-theme-foreground",
    contrast: "low",
    id: "tw-react--site-header--user-profile--user-title"
  }, (_userInfo$title = userInfo === null || userInfo === void 0 ? void 0 : userInfo.title) !== null && _userInfo$title !== void 0 ? _userInfo$title : '')), /*#__PURE__*/React.createElement(ListItem, {
    className: styles['tw-react--site-header--user-profile--list-item']
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "400",
    is: "p",
    className: "--tds-theme-foreground",
    contrast: "low",
    id: "tw-react--site-header--user-profile--user-email"
  }, (_userInfo$email = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== null && _userInfo$email !== void 0 ? _userInfo$email : '')))), (supportLink === null || supportLink === void 0 ? void 0 : supportLink.onClick) && /*#__PURE__*/React.createElement(NavItem, {
    onClick: supportLink.onClick,
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      data: iconHelp
    }),
    id: "tw-react--site-header--user-profile--support-link"
  }, supportLink.title), regionSelector !== null && regionSelector !== void 0 && regionSelector.show ? /*#__PURE__*/React.createElement(NavItem, {
    id: "tw-react--site-header--user-profile--region-selector",
    onClick: function onClick() {
      return regionSelector === null || regionSelector === void 0 ? void 0 : regionSelector.onClick();
    },
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      data: iconGlobe
    })
  }, "".concat(DEFAULT_COUNTRIES_SHORT_PER_REGION[regionSelector === null || regionSelector === void 0 ? void 0 : regionSelector.selectedRegion], " English")) : null, /*#__PURE__*/React.createElement(NavItem, {
    onClick: logout.onClick,
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      data: iconSignOut
    }),
    id: "tw-react--site-header--user-profile--sign-out"
  }, logout.title));
};
UserProfile.defaultProps = {
  supportLink: {},
  regionSelector: {}
};
UserProfile.propTypes = {
  logout: shape({
    title: string.isRequired,
    onClick: func.isRequired
  }).isRequired,
  supportLink: shape({
    title: string,
    onClick: func
  }),
  osAccessToken: string.isRequired,
  regionSelector: shape({
    show: bool,
    onClick: func,
    selectedRegion: string
  })
};

export { UserProfile as default };
